<template>
    <div class="modal simple" v-if="modal" @click="close()">
        <div class="modal-wrap">
            <div class="modal-block" @click.stop>
                <div class="modal-block__close" @click="close()" style="transform: rotate(45deg);">
                    <img src="@/assets/images/icons/icon_plus.svg" width="32" v-if="modal.header">
                    <img src="@/assets/images/icons/icon_plus-b.svg" width="32" v-else>
                </div>
                <div class="modal-promo" v-if="modal.header" :style="{backgroundImage: `url(${require('@/assets/images/jackass.webp')})`}">
                    <h1 v-if="modal.header.title" v-html="modal.header.title"></h1>
                    <img v-if="modal.header.photo" :src="modal.header.photo" :alt="modal.header.title">
                </div>
                <div class="content" v-html="modal.html"></div>
                <Sharing 
                  v-if="modal.sharing"
                  :link="'https://wiildwood.online'"
                  :description="'Сообщество экстремалов, с картой мест, ивентов, групповыми чатами и дальше - больше!'"
                  :title="'Если любишь экстрим - тебе сюда 😉'"
                  :position="'top'"
                  :media="'https://storage.yandexcloud.net/wildwood/brand/OGI.jpg'"
                 />
                <div class="modal-buttons">
                    <div 
                        class="button button_main"
                        v-if="modal.button && (!modal.button.clicked && !clicked)" 
                        @click="buttonHandler(modal.button)"
                    >
                        <p v-if="!loading">
                            {{modal.button.text}}
                        </p>
                        <Loader v-else />
                    </div>
                    <div
                        class="button"
                        v-if="modal.button_close && modal.header" 
                        @click="close()"
                    >
                        {{modal.button_close.text}}
                    </div>
                    <div
                        class="button button_main button_disable"
                        v-if="modal.button.clicked || clicked"
                    >
                        {{ modal.button.clicked_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    data: () => {
        return {
            interviews: null,
            clicked: false,
            loading: false
        }
    },
    computed: {
        modal() {
            return this.$store.getters.getModal
        },
        getInterviewContinue() {
            return !!this.interviews?.find(interview => interview.name === 'need_continue' && interview.agree)
        },
        getUser() {
            return this.$store.getters.getAuthUser
        }
    },
    components: {
        Sharing: () => import('@/components/UI/Sharing'),
        Loader: () => import('@/components/UI/Loader')
    },
    methods: {
        buttonHandler(button) {
            switch (button.type) {
                case 'new_event':
                    this.close()
                    this.$store.dispatch('setNewType', 'events');
                    this.$store.dispatch('changeState', {element: 'workplace'});
                    break;
                case 'external_link':
                    window.open(button.link);
                    break;
                
                case 'set_interview':
                    if (this.getUser) {
                        this.setInterviewContinue()
                    } else {
                        this.$store.dispatch('addNotification', {message: 'Прости, чтобы проголосовать - нужно войти со своим аккаунтом. Чтобы ты случайно не оказался ботом 😉'})
                        this.$router.push('/login')
                    }
                    break;
            
                default:
                    this.close()
                    break;
            }
        },
        async setInterviewContinue() {
            this.loading = true
            let result = await this.$store.dispatch('setInterview', { 
                interview: {
                    name: 'need_continue',
                    agree: true
                }
            });
            result ? this.interviews.push(result) : this.$store.dispatch('addError', { message: 'Не удалось проголосовать' })
            this.loading = false
            this.clicked = this.getInterviewContinue
        },
        close() {
            this.$store.dispatch('closeModal')
        }
    },
    async mounted() {
        console.log(this.modal?.button,'this.modal?.button');
        this.interviews = await this.$store.dispatch('getInterviews');
        this.clicked = this.getInterviewContinue
        console.log(this.interviews,this.getInterviewContinue ,'interviews');
    }
}
</script>

<style lang="stylus">
.modal-promo
    width calc(100% + 40px)
    height 268px
    min-height 268px
    border-radius 25px
    background-size cover
    margin-top -30px
    margin-left -20px
    margin-right -20px
    display flex
    align-items center
    justify-content space-between
    padding 10px 40px
    position relative
    overflow hidden
    +to-width(540px)
        padding 10px 20px
    &:after
        content ''
        position absolute
        left 0
        top 0
        right 0
        bottom 0
        background linear-gradient(90.37deg, rgba(0, 0, 0, 0.4) 0.32%, rgba(45, 45, 45, 0) 99.73%);
    h1
        font-size 40px
        font-weight 900
        text-transform uppercase
        line-height 56px
        color white
        position relative
        z-index 2
        text-shadow 0px 0px 10px rgba(0, 0, 0, 0.25)
        span
            color #53cbb5
        +to-width(460px)
            font-size 32px
            line-height 48px
    img
        max-height 100%
        position relative
        transform rotate(-45deg)
        z-index 2
        +to-width(860px)
            display none

    
.modal.simple
    display block
    +to-width(640px)
        padding 0px

    .content
        padding 20px
        width 100%
        margin-top 0
        +to-width(540px)
            margin-top 20px
            padding 0
        h2
            font-size 32px
            padding-bottom 34px
            text-align center
            font-weight 500
            +to-width(540px)
                font-size 26px
                line-height 32px

        p, ul, ol
            font-size 16px
            // font-weight 500
            color black
            line-height 26px
            padding-bottom 16px
            text-align left
        b, strong
            font-weight 500
        ol
            list-style auto
            padding-left 20px

        span.smile
            font-size 18px
            line-height 16px
        a
            color #519ebd
    
    .modal-wrap
        display flex
        align-items center
        justify-content center
        min-height 100%

    .modal-block
        +to-width(640px)
            height 100%
            border-radius 0
    
    .modal-buttons
        display flex
        flex-wrap wrap
        justify-content center
        align-items center
        +to-width(640px)
            height 100%
            border-radius 0

    .button
        &_main
            border none
            font-size 16px
            padding 18px 25px
            border-radius 15px
            letter-spacing 1px
            font-weight 600
            background linear-gradient(135deg, #FF5F6D 2.88%, #FFC371 100%)
            background linear-gradient(224.86deg, #73CCD8 4.87%, #2B6B9F 96.04%)
            color white
            transition 0.3s all
            &:hover
                border none
                background linear-gradient(224.86deg, #73CCD8 4.87%, #2B6B9F 96.04%)
                box-shadow 0px 0 10px #2B6B9F
        
        &_disable
            border none
            background black
            box-shadow none
            &:hover
                border none
                background black
                box-shadow none
    
    .sharing
        position relative
        margin-bottom 20px
        padding-top 30px
        &:before
            content 'Просто поделись:'
            position absolute
            font-size 15px
            font-weight 600
            white-space nowrap
            top 10px
            left 50%
            transform translateX(-50%)
</style>